import axios from "axios";
import { hostname } from "../hooks/useEndeavour";
import { useMutation } from "@tanstack/react-query";
import { Button, DatePicker, Form, Input, Modal, Radio, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { forwardRef, useImperativeHandle, useState } from "react";

export const CreateNotificationModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [type, setType] = useState();
  const [loading, setLoading] = useState(false);

  const submit = useMutation({
    mutationFn: (data) => {
      return axios
        .post(`${hostname}/pa-alliance/notification/template`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status != 200) {
            message.error("Add Fail");
          }
          message.success("Add Template Success");
          setLoading(false);
          handleCancel();
          props.onChange();
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  const showModal = (values) => {
    setIsModalOpen(true);
    form.setFieldsValue(values);
  };

  const handleOk = (value) => {
    setLoading(true);
    if (value.campaign_id === undefined) {
      delete value.campaign_id;
    }

    submit.mutate(value);
  };

  const handleCancel = () => {
    form.resetFields();
    setType();
    setIsModalOpen(false);
  };

  useImperativeHandle(
    ref,
    () => ({
      showModal,
    }),
    [],
  );

  return (
    <Modal title="Create Notification Template" open={isModalOpen} onCancel={handleCancel} footer={false}>
      <Form form={form} layout="vertical" onFinish={handleOk}>
        {console.log(form.getFieldsValue())}
        <Form.Item name={"channel"} label="Type" rules={[{ required: true }]}>
          <Radio.Group onChange={(e) => setType(e.target.value)} buttonStyle="solid">
            {/* <Radio value="security">Security</Radio> */}
            <Radio value="transactional">Transaction</Radio>
            <Radio value="marketing">Marketing</Radio>
          </Radio.Group>
        </Form.Item>
        {type === "transactional" && (
          <Form.Item name={"transaction_id"} label="Transaction ID" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        )}
        {type !== "transactional" && (
          <>
            <Form.Item name={"page"} label="Page" rules={[{ required: true }]}>
              <Radio.Group>
                <Radio value="homepage">Homepage</Radio>
                <Radio value="rewards">Rewards</Radio>
                <Radio value="concert">Concert</Radio>
                <Radio value="hotel">Hotel</Radio>
                <Radio value="airport_lounge">Airport Lounge</Radio>
                <Radio value="luxury">Luxury</Radio>
                <Radio value="lucky-draw">Lucky Draw</Radio>
              </Radio.Group>
            </Form.Item>
          </>
        )}
        <Form.Item name={"campaign_id"} label="Campaign ID" hidden>
          <Input />
        </Form.Item>
        <Form.Item name={"body"} label="Content" rules={[{ required: true }]}>
          <TextArea rows={6} maxLength={1500} />
        </Form.Item>

        <Button htmlType="submit" block type="primary" loading={loading}>
          Submit
        </Button>
      </Form>
    </Modal>
  );
});
